import Vue from "vue";
import Router from "vue-router";
import constants from "../constants";
import lodash from "lodash";
import main from "../main";

const ComboDetail = () => import("@/components/combo/ComboDetail.vue");
const Register = () => import("@/pages/Register.vue");
const ForgotPassword = () => import("@/pages/ForgotPassword.vue");
const SetNewPassWord = () => import("@/pages/SetNewPassword.vue");
const Profile = () => import("@/pages/Profile.vue");
const EditProfile = () => import("@/pages/EditProfile.vue");
const Ponta = () => import("@/pages/Ponta.vue");
const AddLocation = () => import("@/pages/Location.vue");
const Careers = () => import("@/pages/static/Career.vue");
const News = () => import("@/pages/static/News.vue");
const Aboutus = () => import("@/pages/static/Aboutus.vue");
const ReHeatYouPizza = () => import("@/pages/static/ReHeatYourPizza.vue");
const Sitemap = () => import("@/pages/static/Sitemap.vue");
const History = () => import("@/pages/History.vue");
const Post = () => import("@/pages/static/Post.vue");
const AllergenInformation = () => import("@/pages/static/AllergenInformation.vue");
const Crs = () => import("@/pages/static/Crs.vue");
const TestLocalization = () => import("@/pages/TestLocalization.vue");
const ResultLocalization = () => import("@/pages/ResultLocalization.vue");
const Confirmation = () => import("@/pages/Confirmation.vue");
const PaymentStatus = () => import("@/pages/PaymentStatus.vue");
const TopicList = () => import("@/pages/TopicList.vue");
const TopicDetail = () => import("@/pages/TopicDetail.vue");
const Campaign = () => import("@/pages/Campaign.vue");
const CouponAttachment = () => import("@/pages/CouponAttachment.vue");
const HomePage = () => import("@/pages/Home.vue");
const Home2 = () => import("@/pages/Home2.vue");
const HutPage = () => import("@/pages/Hut.vue");
const CategoryPage = () => import("@/pages/Category.vue");
const ContactPage = () => import("@/pages/static/Contact2.vue");
const LoginPage = () => import("@/pages/Login.vue");
const CheckoutPage = () => import("@/pages/CheckOut.vue");
const TrackerOrder = () => import("@/pages/TrackerOrder.vue");
const Tracking = () => import("@/pages/Tracking.vue");
const CreditCardPayment = () => import("@/pages/CreditCardPayment.vue");
const CybersourcePayment = () => import('@/pages/CybersourcePayment.vue')
const MayBank2UPayment = () => import("@/pages/MayBank2UPayment.vue");
// const GameSlot = () => import('@/pages/GameSlot.vue');
// const GameReward = () => import('@/pages/GameReward.vue');
// const GameSuccess = () => import('@/pages/GameSuccess.vue');
const Rakuten = () => import("@/components/Rakuten.vue");
const AllergeyNutrition = () => import("@/pages/AllergeyNutrition.vue");
const Franchising = () => import("@/pages/static/Franchising.vue");
const HelpPage = () => import("@/pages/Help.vue");
const FindAHut = () => import("@/components/partials/FindHut.vue");
const Preferences = () => import("@/pages/Preferences.vue");
const PageNotFound = () => import("@/pages/static/404.vue");
const PageNewApps = () => import("@/pages/static/NewApps");
const HutRewards = () => import("@/pages/HutRewards.vue");
const NoTouch = () => import("@/pages/NoTouch.vue");
const LandingMyBox = () => import("@/pages/LandingMyBox.vue");
const LandingSweetSour = () => import("@/pages/LandingSweetSour.vue");
const LandingPestaPizza = () => import("@/pages/LandingPestaPizza.vue");
const Vouchers = () => import("@/pages/Vouchers.vue");
const TrackerOrderVoucher = () => import("@/pages/TrackerOrderVoucher.vue");
const SliceHistory = () => import('@/pages/SliceHistory.vue')

Vue.use(Router);

let router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (to.name == "home") {
      return { x: 0, y: 0 };
    }
  },
  hashbang: false,
  mode: "history",
  history: true,
  routes: [
    {
      path: "/home2",
      name: "home2",
      meta: {
        layout: "home2",
        meta_title: "meta.home.title",
        meta_description: "meta.home.description"
      },
      component: Home2
    },
    {
      path: "/hut-rewards",
      name: "hut-rewards",
      component: HutRewards,
      meta: { layout: "simple"}
    },
    {
      path: '/slice-history',
      name: 'slice_history',
      component: SliceHistory,
      meta: {layout: 'simple', key_title: 'slice_history', meta_title: 'slice_history', auth: true}
    },
    {
      path: "/notouch",
      name: "notouch",
      component: NoTouch,
      meta: { layout: "simple", key_title: "header.notouch" }
    },
    {
      path: "/huts/:outlet",
      name: "huts",
      meta: { layout: "home-landing" }, //home-landing
      component: HutPage
    },
    {
      path: "/order/:slug?/:sub?/:nameseo?", // change uuid to nameseo
      name: "category",
      meta: { layout: "main" },
      component: CategoryPage
    },
    {
      path: "/contact",
      beforeEnter: (to, from, next) => {
        window.location.href = 'https://docs.google.com/forms/d/e/1FAIpQLSdaerxncxPE1gMVzGNinYIF7B3ljm1hP4mxJIqXdP-rwJlJBg/viewform?pli=1';
      }
    },
    {
      path: "/reheatyourpizza",
      name: "reheat-your-pizza",
      meta: { layout: "simple", key_title: "header.reheatyourpizza" },
      component: ReHeatYouPizza
    },
    {
      path: "/sitemap",
      name: "sitemap",
      meta: { layout: "simple", key_title: "header.sitemap" },
      component: Sitemap
    },
    {
      path: "/help",
      name: "help",
      meta: { layout: "simple", key_title: "header.help" },
      component: HelpPage
    },
    {
      path: "/find-a-hut",
      name: "find-a-hut",
      component: FindAHut,
      meta: { layout: "simple", key_title: "header.findahut" }
    },
    {
      path: "/login/:method?",
      props: true,
      name: "login",
      component: LoginPage,
      meta: { layout: "simple", key_title: "header.login" }
    },
    {
      path: "/signup",
      name: "signup",
      component: Register,
      meta: {
        layout: "simple",
        key_title: "header.join_hut_rewards",
        auth: false
      }
    },
    {
      path: "/preferences",
      component: Preferences,
      meta: { layout: "simple", key_title: "header.preferences", auth: true }
    },
    {
      path: "/getmypassword",
      component: ForgotPassword,
      meta: { layout: "simple", key_title: "header.reset_password" }
    },
    {
      path: "/setnewpassword/:token",
      component: SetNewPassWord,
      meta: { layout: "simple", key_title: "header.create_new_password" }
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        layout: "simple",
        key_title: "header.my_account_information",
        auth: true
      }
    },
    {
      path: "/edit-profile",
      component: EditProfile,
      meta: {
        layout: "simple",
        key_title: "header.update_information",
        auth: true
      }
    },
    {
      path: "/ponta-attach",
      name: "ponta-attach",
      component: Ponta,
      meta: { layout: "simple", key_title: "header.ponta", auth: true }
    },
    {
      path: "/checkout",
      name: "checkout",
      component: CheckoutPage,
      meta: { layout: "simple", key_title: "header.secure_checkout" }
    },
    {
      path: "/credit-payment/:transaction?/:payment_url?",
      name: "credit-payment",
      component: CreditCardPayment,
      meta: { layout: "simple", key_title: "header.credit_card" }
    },
    {
      path: '/cybersource-payment/:uuid?',
      name: 'cybersource-payment',
      component: CybersourcePayment,
      meta: {layout: 'simple', 'key_title': 'header.credit_card'}
    },
    {
      path: "/maybank2u-payment/:transaction?/:payment_url?",
      name: "maybank2u-payment",
      component: MayBank2UPayment,
      meta: { layout: "simple" }
    },
    {
      path: "/tracker-order/:uuid?",
      name: "tracker-order",
      component: TrackerOrder,
      meta: { layout: "simple", key_title: "header.thanks_for_your_order" }
    },
    {
      path: "/tracking",
      name: "tracking",
      component: Tracking,
      meta: { layout: "simple", key_title: "header.track_your_order" }
    },
    {
      path: "/add-location/:id?",
      name: "add-location",
      component: AddLocation,
      meta: { layout: "simple", key_title: "header.location" }
    },
    {
      path: "/payment-status/:transaction?",
      name: "payment-status",
      component: PaymentStatus,
      meta: { layout: "simple", key_title: "header.thanks_for_your_payment" }
    },
    {
      path: "/aboutus/:id?",
      name: "aboutus",
      component: Aboutus,
      meta: { layout: "simple", key_title: "header.aboutus" }
    },
    {
      path: "/careers/:id?",
      name: "careers",
      component: Careers,
      meta: { layout: "simple", key_title: "header.careers" }
    },
    {
      path: "/news/:year?/:month?/:url?",
      name: "news",
      component: News,
      meta: { layout: "simple", key_title: "header.news" }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Post,
      meta: { layout: "simple", key_title: "header.policy" },
      props: { type: "privacy_policy", name: "policy" }
    },
    {
      path: "/terms",
      name: "terms",
      component: Post,
      meta: { layout: "simple", key_title: "header.terms" },
      props: { type: "term_and_condition", name: "terms" }
    },
    {
      path: '/halal_policy',
      name: 'halal-policy',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.halal_policy'},
      props: {type: 'delivery_policy', name: 'delivery policy'}
    },
    {
      path: '/membership',
      name: 'membership',
      component: Post,
      meta: { layout: "simple", key_title: "header.membership" },
      props: { type: "membership_information", name: "membership" }
    },
    {
      path: "/indication-based",
      name: "indication",
      component: Post,
      meta: { layout: "simple", key_title: "header.indication" },
      props: {
        type: "cmn_commercial_transactions",
        name: "commercial-transactions"
      }
    },
    {
      path: "/nutritional-content",
      name: "nutritional",
      component: Post,
      meta: { layout: "simple", key_title: "header.nutritional" },
      props: { type: "prd_allergen", name: "nutritional" }
    },
    {
      path: "/faq",
      name: "faq",
      component: Post,
      meta: { layout: "simple", key_title: "header.faq" },
      props: { type: "faq", name: "faq" }
    },
    {
      path: "/allergen-information",
      name: "allergenInformation",
      component: AllergenInformation,
      meta: { layout: "simple", key_title: 'Allergen Information' }
    },
    {
      path: "/crm/coupon/:code?",
      name: "coupon-attach",
      component: CouponAttachment,
      meta: { layout: "simple", key_title: "header.coupon_attachment" },
      props: true
    },
    /*{
				path: '/term',
				name: 'term',
				component: Term,
				meta: {layout: 'simple', 'key_title': 'header.terms'}
		},*/
    {
      path: "/crs/:mode?/:sub?",
      name: "crs",
      component: Crs,
      meta: { layout: "simple", key_title: "header.crs" }
    },
    {
      path: "/history",
      component: History,
      meta: { layout: "simple", key_title: "header.history", auth: true }
    },
    {
      path: "/404",
      name: "error-404",
      component: PageNotFound,
      meta: { layout: "not-found" }
    },
    {
      path: "/403",
      name: "error-403",
      component: { template: "<p>403</p>" }
    },
    {
      path: "/combo-detail/:nameseo/:ssid?/:coupon?",
      name: "combo-detail",
      component: ComboDetail,
      meta: { layout: "combo", key_title: "header.combo_detail" }
    },
    {
      path: "/localization/:zip/:opt?",
      name: "test-localization",
      component: TestLocalization,
      meta: {
        layout: "simple",
        key_title: "postal_code",
        sub_title: "localization.sub_title_result_search",
        key_params: "zip"
      }
    },
    {
      path: "/result-localization/:zip/:opt?",
      name: "result-localization",
      component: ResultLocalization,
      meta: {
        layout: "simple",
        key_title: "localization.title_result_search",
        key_params: "zip"
      }
    },
    {
      path: "/confirmation/:regis",
      name: "confirmation",
      component: Confirmation,
      meta: {
        layout: "simple",
        key_title: "registration.thankyou",
        key_params: "regis"
      }
    },
    {
      path: "/",
      name: "home",
      meta: {
        layout: "home",
        meta_title: "meta.home.title",
        meta_description: "meta.home.description"
      },
      component: HomePage
    },
    {
      path: "/topic",
      name: "topic",
      component: TopicList,
      meta: { layout: "main" }
    },
    {
      path: "/topic/:name/:code?",
      name: "topic-detail",
      component: TopicDetail,
      meta: { layout: "main", key_title: "header.topic" }
    },
    {
      path: "/campaign/:campaignName",
      name: "campaign",
      component: Campaign,
      meta: { layout: "Simple", key_title: "header.campaign" }
    },
    // {
    //   path: '/slot',
    //   name: 'game_slot',
    //   component: GameSlot,
    //   meta: {layout: 'null'},
    // },
    // {
    //   path: '/slot_reward',
    //   name: 'game_slot_reward',
    //   component: GameReward,
    //   meta: {layout: 'null'},
    // },
    // {
    //   path: '/slot_success',
    //   name: 'game_slot_success',
    //   component: GameSuccess,
    //   meta: {layout: 'null'},
    // },
    {
      path: "/allergey-nutrition/:uuid",
      component: AllergeyNutrition,
      meta: {
        layout: "simple",
        key_title: "header.allergey_nutrition",
        auth: false
      }
    },
    {
      path: "/landing-mybox",
      name: "landing-mybox",
      component: LandingMyBox,
      meta: { layout: "landing" },
      redirect: { name: "home" }
    },
    {
      path: "/1klikje",
      name: "landing-sweet-sour",
      component: LandingSweetSour,
      meta: { layout: "not-found" }
    },
    {
      path: "/landing-pesta-pizza",
      name: "landing-pesta-pizza",
      component: LandingPestaPizza,
      meta: { layout: "landing" }
    },
    {
      path: "/home",
      redirect: { name: "home" }
    },
    {
      path: "/vouchers",
      name: "vouchers",
      component: Vouchers,
      meta: { layout: "voucher" }
    },
    {
      path: "/tracker-order-voucher/:uuid?",
      name: "tracker-order-voucher",
      component: TrackerOrderVoucher,
      meta: { layout: "simple", key_title: "header.thanks_for_your_order" }
    },
    {
      path: "/",
      // redirect: {name: 'home'},
      beforeEnter: (to, from, next) => {
        const login = [
          "/pc/cpn_search",
          "/pc/user_password_reset",
          "/pc/user_detail.2",
          "/pc/user_base_modify.3",
          "/pc/user_password_modify.5",
          "/pc/user_mail_modify.7",
          "/user_mail_modify_confirm.8",
          "/user_mail_modify_mail_sent.9",
          "/pc/user_family_modify.13",
          "/pc/user_pontacard_modify.15"
        ];
        const topics = ["/pc/topics"];
        const faq = ["/pc/general/include/cmn_inquiry.html"];
        const member = ["/pc/general/include/usr_member_rules.html"];

        const nutrition = [
          "/pc/general/include/prd_allergen.html?link_id=cft_par"
        ];
        const actTrade = [
          "/pc/general/include/cmn_commercial_transactions.html?link_id=cft_cct"
        ];

        const stores = ["/ip/shop_detail", "/pc/shop_detail"];

        for (let i in stores) {
          if (lodash.startsWith(to.fullPath, stores[i])) {
            let path = to.fullPath.split("/");
            if (path.length >= 4) {
              return next("/huts/" + path[3]);
            }
          }
        }

        for (let i in topics) {
          if (lodash.startsWith(to.fullPath, topics[i])) {
            return next("/topic");
          }
        }

        for (let i in login) {
          if (lodash.startsWith(to.fullPath, login[i])) {
            return next("/login");
          }
        }

        for (let i in faq) {
          if (lodash.startsWith(to.fullPath, faq[i])) {
            return next("/faq");
          }
        }

        for (let i in member) {
          if (lodash.startsWith(to.fullPath, member[i])) {
            return next("/membership");
          }
        }

        for (let i in nutrition) {
          if (lodash.startsWith(to.fullPath, nutrition[i])) {
            return next("/nutritional-content");
          }
        }

        for (let i in actTrade) {
          if (lodash.startsWith(to.fullPath, actTrade[i])) {
            return next("/indication-based");
          }
        }
        next("/");
      }
    },
    {
      path: "/cgi-bin/linkshare",
      component: Rakuten
    },
    {
      path: "/become-a-franchisee",
      name: "franchising",
      component: Franchising,
      meta: { layout: "simple", key_title: "header.franchising" }
    },
    {
      path: "/new-apps",
      component: PageNewApps,
      meta: { layout: "not-found" }
    },
    {
      path: "*",
      beforeEnter: (to, from, next) => {
        const OldCategoryURL = [
          "/category/beverages",
          "/category/pastas",
          "/category/pizzas",
          "/category/promos",
          "/category/sides"
        ];

        const OldPizzaURL = ["/category/pizza"];
        const OldMyBoxURL = ["/category/mybox"];
        const OldFindHutURL = ["/findahut"];
        const OldTermURL = ["/term"];
        const OldTrackingURL = ["/tracker"];
        const OldCouponURL = ["/category/pizzahutcoupon"];

        const pageNotFound = [
          "/order/mybox",
          "/category/promos/alacarte50percentoff",
          "/category/promos/3pizzas"
        ];

        for (let i in pageNotFound) {
          if (lodash.startsWith(to.fullPath, pageNotFound[i])) {
            return next("/404");
          }
        }

        for (let i in OldCouponURL) {
          if (lodash.startsWith(to.fullPath, OldCouponURL[i])) {
            return next("/order/coupons");
          }
        }

        for (let i in OldPizzaURL) {
          if (lodash.startsWith(to.fullPath, OldPizzaURL[i])) {
            return next("/order/pizzas");
          }
        }

        for (let i in OldCategoryURL) {
          let param = getParamFromOldCategoryURL(OldCategoryURL[i]);
          if (to.fullPath.indexOf(param) !== -1) {
            return next(`/order/${param}`);
          }
        }

        for (let i in OldFindHutURL) {
          if (lodash.startsWith(to.fullPath, OldFindHutURL[i])) {
            return next("/find-a-hut");
          }
        }

        for (let i in OldTermURL) {
          if (lodash.startsWith(to.fullPath, OldTermURL[i])) {
            return next("/terms");
          }
        }

        for (let i in OldTrackingURL) {
          if (lodash.startsWith(to.fullPath, OldTrackingURL[i])) {
            return next("/tracking");
          }
        }

        for (let i in OldMyBoxURL) {
          if (lodash.startsWith(to.fullPath, OldMyBoxURL[i])) {
            return next("/order/promos/mybox");
          }
        }

        next({ path: "/404", query: to.query });
      }
    },
    {
      path: '/e-invoice',
      name: 'e-invoice',
      component: Post,
      meta: {layout: 'simple', 'key_title': 'header.e_invoice'},
      props: {type: 'register_term_and_condition', name: 'FAQ'}
    }
  ]
});

router.beforeResolve((to, from, next) => {

  if (from.name === "topic-detail" && to.name === "category") {
    main.$root.$emit('loadposition')
  }

  if (
    (from.name &&
      !main.$const.PAGE_NOT_REMOVE_DISPOSITION.includes(from.name) &&
      to.name == "vouchers") ||
    (to.name == "payment-status" && main.$session.get("vouchers"))
  ) {
    main.removeDispositionAndCart(main);
  }

  if (
    !main.$const.PAGE_NOT_REMOVE_DISPOSITION.includes(to.name) &&
    main.$session.get("vouchers")
  ) {
    var session_cart = main.$session.get("cart");
    if (
      session_cart &&
      Object.keys(session_cart).length != 0 &&
      session_cart.data &&
      session_cart.data.length != 0
    ) {
      main.$router.push({ name: from.name ? from.name : "vouchers" });
      main.$modal.show("dialog", {
        text: main.$t("confirm_out_voucher"),
        buttons: [
          {
            title: main.$t("button_yes"),
            handler: () => {
              main.$modal.hide("dialog");
              main.removeDispositionAndCart(main);
              main.$root.$emit("closePopUpClosing");
              main.$router.push({
                name: to.name,
                params: { slug: to.params.slug }
              });
            }
          },
          {
            title: main.$t("button_close"),
            handler: () => {
              main.$modal.hide("dialog");
              main.$root.$emit("closePopUpClosing");
            }
          }
        ]
      });
    } else {
      main.removeDispositionAndCart(main);
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  let title = main.$t(to.meta.meta_title);
  let description = main.$t(to.meta.meta_description);

  if (!title) {
    title = main.$t("meta.home.title");
  }
  if (!description) {
    description = main.$t("meta.home.description");
  }

  switch (to.name) {
    case "category":
      if (to.params.slug == "promos") {
        title = main.$t("meta.promos.title");
        description = main.$t("meta.promos.description");
        if (to.params.sub && to.params.sub == "mybox") {
          title = main.$t("meta.mybox.title");
          description = main.$t("meta.mybox.description");
        }
      } else if (to.params.slug == "pizzas") {
        title = main.$t("meta.pizzas.title");
        description = main.$t("meta.pizzas.description");
      } else if (to.params.slug == "pasta-gratin") {
        title = main.$t("meta.pasta_gratin.title");
        description = main.$t("meta.pasta_gratin.description");
      } else if (
        to.params.slug == "sides" ||
        (to.params.slug == "sides" && to.params.sub == "potato-chicken")
      ) {
        title = main.$t("meta.sides.title");
        description = main.$t("meta.sides.description");
      } else if (to.params.slug == "beverages") {
        title = main.$t("meta.beverages.title");
        description = main.$t("meta.beverages.description");
      } else if (to.params.slug == "pastas") {
        title = main.$t("meta.pastas.title");
        description = main.$t("meta.pastas.description");
      } else if (to.params.slug == "coupons") {
        title = main.$t("meta.coupons.title");
        description = main.$t("meta.coupons.description");
      } else if (to.params.slug == "drink-dessert") {
        title = main.$t("meta.drink_dessert.title");
        description = main.$t("meta.drink_dessert.description");
      } else if (to.params.slug == "coupons") {
        title = main.$t("meta.coupons.title");
        description = main.$t("meta.coupons.description");
      }
      break;
    case "home":
      title = main.$t("meta.home.title");
      description = main.$t("meta.home.description");
      break;
    case "faq":
      title = main.$t("meta.faq.title");
      description = main.$t("meta.faq.description");
      break;
    case "aboutus":
      title = main.$t("meta.aboutus.title");
      description = main.$t("meta.aboutus.description");
      break;
    case "crs":
      title = main.$t("meta.crs.title");
      description = main.$t("meta.crs.description");
      break;
    case "news":
      title = main.$t("meta.news.title");
      description = main.$t("meta.news.description");
      break;
    case "notouch":
      title = main.$t("meta.notouch.title");
      description = main.$t("meta.notouch.description");
      break;
    case "indication":
      title = main.$t("meta.indication_based.title");
      description = main.$t("meta.indication_based.description");
      break;
    case "membership":
      title = main.$t("meta.membership.title");
      description = main.$t("meta.membership.description");
      break;
    case "nutritional":
      title = main.$t("meta.nutritional_content.title");
      description = main.$t("meta.nutritional_content.description");
      break;
    case "privacy":
      title = main.$t("meta.privacy.title");
      description = main.$t("meta.privacy.description");
      break;
    case "terms":
      title = main.$t("meta.terms.title");
      description = main.$t("meta.terms.description");
      break;
    case "topic":
      title = main.$t("meta.topic.title");
      description = main.$t("meta.topic.description");
      break;
    case "find-a-hut":
      title = main.$t("meta.find-a-hut.title");
      description = main.$t("meta.find-a-hut.description");
      break;
    case "hut-rewards":
      title = main.$t("meta.hut_rewards.title");
      description = main.$t("meta.hut_rewards.description");
      break;
    case "signup":
      title = main.$t("meta.signup.title");
      description = main.$t("meta.signup.description");
      break;
    case "tracking":
      title = main.$t("meta.tracking.title");
      description = main.$t("meta.tracking.description");
      break;
    case "test-localization":
      if (to.params.zip == "_select") {
        title = main.$t("meta.localization_select");
      } else if (to.params.zip.indexOf("found") >= 0) {
        title = main.$t("meta.localization_select");
      }
      break;
    case "landing-mybox":
      title = main.$t("meta.landing_mybox.title");
      description = main.$t("meta.landing_mybox.description");
      break;
    case "landing-sweet-sour":
      title = main.$t("meta.landing_sweet_sour.title");
      description = main.$t("meta.landing_sweet_sour.description");
      break;
  }
  document.title = main.$t(title);

  if (document.getElementsByTagName("meta")["description"] === undefined) {
    let meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    meta.setAttribute("content", main.$t(description));
    document.head.appendChild(meta);
  } else {
    let descriptionEl = document.getElementsByTagName("meta")["description"];
    descriptionEl.content = description;
  }

  if (to.name == "privacy" || to.name == "terms" || to.name == "login") {
    let meta = document.createElement("meta");
    meta.setAttribute("name", "googlebot");
    meta.setAttribute("content", "noindex");
    document.head.appendChild(meta);
  }

  const curFullURL = `https://${window.location.hostname}${to.fullPath}`;

  /**
   * Canonical
   *    example: <link rel="canonical" href="https://www.pizzahut.com.my" />
   */
  const existedCanonical = document.querySelector('[rel="canonical"]');
  if (existedCanonical) {
    existedCanonical.remove();
  }
  let canonicalEl = document.createElement("link");
  canonicalEl.setAttribute("rel", "canonical");
  canonicalEl.setAttribute("href", curFullURL);
  document.head.appendChild(canonicalEl);

  /**
   * HrefLang
   *    example: <link rel="alternate" href="https://www.pizzahut.com.my" hreflang=" en-MY" />
   */
  const existedHreflangEl = document.querySelector('[rel="alternate"]');
  if (existedHreflangEl) {
    existedHreflangEl.remove();
  }
  let hrefLangEl = document.createElement("link");
  hrefLangEl.setAttribute("rel", "alternate");
  hrefLangEl.setAttribute("href", curFullURL);
  hrefLangEl.setAttribute("hreflang", "en-MY");
  document.head.appendChild(hrefLangEl);
});

const getParamFromOldCategoryURL = function(fullPath) {
  let result = fullPath.replace("/category/", "");
  result.trim();

  return result;
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js